<div class="container-fluid d-flex flex-column px-0 h-100">
    <div class="d-flex flex-row justify-content-between py-2 pl-3 pr-4 chat-menu">
        <div class="d-flex flex-row">
            <img class="profile-img" *ngIf="roomDetails?.mum && roomDetails?.mum?.profileImage"
                [src]="roomDetails?.mum?.profileImage">
            <img class="profile-img" *ngIf="roomDetails?.midwife && roomDetails?.midwife?.profileImage"
                [src]="roomDetails?.midwife?.profileImage">
            <img class="profile-img" src="../../../../../../assets/Images/pro-pic.png"
                *ngIf="!roomDetails?.midwife?.profileImage && !roomDetails?.mum?.profileImage">
            <div class="d-flex flex-column ml-2 mt-1">
                <span class="profile-name" *ngIf="roomDetails?.mum">{{roomDetails?.mum?.name}}</span>
                <span class="profile-name" *ngIf="roomDetails?.midwife">{{roomDetails?.midwife?.name}}</span>
            </div>
        </div>
        <div class="d-flex flex-row mt-3">
            <img src="../../../../../assets/Images/search.svg" height="16" width="16" class="mr-4 action-icons">
            <img src="../../../../../assets/Images/download.svg" height="16" width="16" class="mr-4 action-icons"
            (click)="generatePDF()">
            <img src="../../../../../assets/Images/arrow-cross-2.svg" height="16" width="16" class="action-icons"
                [routerLink]="['/dashboard']">
            <img src="../../../../../assets/Images/cross.svg" height="16" width="16" class="action-icons d-md-none ml-4"
            (click)="closeChat()">
        </div>
    </div>
    <div #scrollMe class="py-2 px-4 message-section" infiniteScroll [infiniteScrollDistance]="1"
        [infiniteScrollThrottle]="50" (scrolledUp)="loadMoreChats()" [scrollWindow]="false">
        <div class="message" *ngFor="let message of messages; let i = index"
            [ngClass]="{'float-right': userId != message.userId}">
            <span class="date-divider mb-1" *ngIf="i == 0 || messages[i].dateConverted != messages[i-1].dateConverted">
                {{message.timestamp | date:'EEE dd MMM, yyyy'}}</span>
            <div [ngClass]="{'message-text-section-you': userId != message.userId, 
            'message-text-section-me': userId == message.userId, 'attachment': message.type == 'attachment'}"
                class="d-flex flex-column py-1">
                <img src="../../../../../assets/Images/download-circle.svg" height="40" width="40"
                    class="my-3 mx-auto action-icons" (click)="downloadAttachment(message)" *ngIf="message.type == 'attachment'">
                <hr class="mx-0 mt-0 mb-1" *ngIf="message.type == 'attachment'">
                <span class="message-text">{{message.message}}</span>
            </div>
            <span class="message-time" [ngClass]="{'text-right': userId == message.userId}">{{message.timestamp |
                date:'h:mm a'}}</span>
        </div>
    </div>
    <div class="message-box py-2">
        <input (change)="uploadFile($event)" type="file" accept=".jpg,.jpeg,.doc,.docx,.txt,.pdf,.png" #fileInput
            class="d-none">
        <img src="../../../../../assets/Images/attachment.svg" height="22" width="22" class="my-2 mx-3 action-icons"
            (click)="fileInput.click()">
        <input class="form-control form-control-lg message-input" placeholder="Type your message"
            (keyup.enter)="sendMessage()" [(ngModel)]="message" [disabled]="inputBox" #inputField>
        <img src="../../../../../assets/Images/cross.svg" class="my-2 mx-2 action-icons clear" (click)="reset()"
            *ngIf="inputBox">
        <img src="../../../../../assets/Images/send.svg" height="18" width="22" class="my-2 mx-3 action-icons"
            (click)="sendMessage()" [ngClass]="{disable: !message.length}">
    </div>
</div>